import LoginView from "@/modules/login/views/LoginView";
import ProviderLoginView from "@/modules/login/views/ProviderLoginView";
import LogoutView from "@/modules/login/views/LogoutView";
import PostLogoutView from "@/modules/login/views/PostLogoutView";

export const LoginRoutes = [
    {
        path: '/login',
        component: LoginView,
    },
    {
        path: '/login/:provider',
        component: ProviderLoginView,
    },
    {
        path: '/api/idpauth',
        component: ProviderLoginView,
    },
    {
        path: '/logout',
        component: LogoutView,
    },
    {
        path: '/post-logout',
        component: PostLogoutView,
    }
];

